"use client";

import Image from "next/image";
import Link from "next/link";

export default function AICBadge({ variant = "default" }) {
  const isCompact = variant === "compact";

  return (
    <div
      className={`${
        isCompact ? "p-4" : "p-6"
      } bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-shadow`}
    >
      <div className={`flex ${isCompact ? "flex-row items-center gap-4" : "flex-col sm:flex-row items-center sm:items-start gap-6"}`}>
        {/* AIC Logo */}
        <div className="flex-shrink-0">
          <Image
            src="/aic-logo-square.png"
            alt="Appraisal Institute of Canada Logo"
            width={80}
            height={80}
            className="w-16 h-16 sm:w-20 sm:h-20 object-contain"
          />
        </div>

        {/* Content */}
        <div className={`${isCompact ? "" : "text-center sm:text-left"} flex-1`}>
          <h3 className={`${isCompact ? "text-base" : "text-lg"} font-bold text-gray-900 dark:text-white mb-1`}>
            AIC Designated Appraiser
          </h3>

          <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
            Mushtaq Khan, <span className="font-semibold">CRA, P.App.</span>
          </p>

          <div className="flex flex-wrap gap-2 mb-3 justify-center sm:justify-start">
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300">
              CUSPAP Compliant
            </span>
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300">
              Insured
            </span>
          </div>

          <a
            href="https://www.aicanada.ca/appraisers/910564"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm text-blue-600 dark:text-blue-400 hover:underline font-medium"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              />
            </svg>
            Verify Credentials on AIC
            <svg
              className="w-3 h-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>
          </a>
        </div>
      </div>

      {/* Bottom info bar - only on default variant */}
      {!isCompact && (
        <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
          <p className="text-xs text-gray-500 dark:text-gray-400 text-center sm:text-left">
            Member of the Appraisal Institute of Canada. Reports comply with Canadian Uniform Standards of Professional Appraisal Practice (CUSPAP) and are prepared for the agreed tax, legal, or financial use.
          </p>
        </div>
      )}
    </div>
  );
}

// Inline footer version
export function AICBadgeInline() {
  return (
    <a
      href="https://www.aicanada.ca/appraisers/910564"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 text-sm text-blue-500 dark:text-white/90 hover:text-blue-700 dark:hover:text-white transition-colors"
    >
      <Image
        src="/aic-logo-square.png"
        alt="AIC"
        width={20}
        height={20}
        className="w-5 h-5 object-contain"
      />
      <span className="font-medium">AIC Designated Appraiser</span>
      <svg
        className="w-3 h-3 opacity-70"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
        />
      </svg>
    </a>
  );
}
